import produce from 'immer';

import {
  MemberActionType,
  SetEventFilterPayload,
  SetMemberByIdPayload,
  SetEventsPayload,
} from 'types/reduxTypes/ActionTypes/memberActionTypes';
import { MembersStateType } from 'types/reduxTypes/StateTypes';
import { membersDefaultState } from '../../utils/defaultStates/MemberDefaultState';
import { types } from '../../actions/memberDetails';

const defaultState: MembersStateType = membersDefaultState;

const handleSetMemberById = (state: MembersStateType, payload: SetMemberByIdPayload) => {
  state.selectedMember.data = payload.member;
  return state;
};

const handleSetPastEvents = (state: MembersStateType, payload: SetEventsPayload) => {
  state.selectedMember.pastEvents = payload.events;
  return state;
};

const handleSetUpcomingEvents = (state: MembersStateType, payload: SetEventsPayload) => {
  state.selectedMember.upcomingEvents = payload.events;
  return state;
};

const handleSetEventFilter = (state: MembersStateType, payload: SetEventFilterPayload) => {
  state.selectedMember.eventFilter = payload.eventFilter;
  return state;
};

// eslint-disable-next-line default-param-last
export default produce((state: MembersStateType = defaultState, action: MemberActionType) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_EVENT_FILTER_TYPE: {
      return handleSetEventFilter(state, <SetEventFilterPayload> payload);
    }
    case types.SET_MEMBER_BY_ID: {
      return handleSetMemberById(state, <SetMemberByIdPayload> payload);
    }
    case types.SET_PAST_EVENTS: {
      return handleSetPastEvents(state, <SetEventsPayload> payload);
    }
    case types.SET_UPCOMING_EVENTS: {
      return handleSetUpcomingEvents(state, <SetEventsPayload> payload);
    }
    case types.RESET_MEMBER_DETAILS: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
});
